<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <!-- 门店 -->
        <el-form-item label="门店" prop="branchId">
          <el-select
            v-model="form.branchId"
            placeholder="请选择门店"
            @change="branchChange"
            class="fix-width"
          >
            <el-option
              v-for="item in branchList"
              :key="item.branchId"
              :label="item.title"
              :value="item.branchId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="图标" prop="icon">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <img v-if="form.icon" :src="form.icon" class="avatar" />
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
          <span>建议尺寸：128px * 128px</span>
        </el-form-item>
        <el-form-item label="餐厅" prop="restaurantIdList">
          <el-checkbox-group v-model="form.restaurantIdList">
            <el-checkbox v-for="item of restaurantList" :label="item.restaurantId" :key='item.restaurantId'>{{item.title}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="打印机" prop="printerIdList" v-if="printerList.length>0">
          <el-checkbox-group v-model="form.printerIdList">
            <el-checkbox v-for="item of printerList" :label="item.printerId" :key='item.printerId'>{{item.title}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createTag, updateTag ,findAll} from '@/api/food'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
import { getAllBranchs } from '@/api/branch'
import { findPrinterAll } from '@/api/settings'
export default {
  name: 'FoodTagEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken: null,
      restaurantList:[],
      branchList: [],
      printerList:[],
      form: {
        tagId: '',
        title: '',
        branchId: '',
        icon: '',
        restaurantIdList: [],
        printerIdList:[],
        order: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        icon: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请上传图标'))
              } else {
                callback()
              }
            },
          },
        ],
        restaurantIdList:[{
            required: true,
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请至少选择一个餐厅'))
              } else {
                callback()
              }
            },
          }],
          branchId: [{ required: true, trigger: 'blur', message: '请选择门店' }],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    branchChange(branchId) {
      this.findPrinterAll(branchId)
    },
    //获取所有门店
    async getAllBranchs() {
      const res = await getAllBranchs({})
      if (!res) return
      this.branchList = res
    },
    //获取所有打印机
    async findPrinterAll() {
      const res = await findPrinterAll({})
      if (!res) return
      this.printerList = res
    },
    async showEdit(row) {
      if (row) {
        this.title = '修改菜品标签'
        this.form = Object.assign(this.form, row.basic)
        this.form.tagId = row.tagId
        this.form.title = row.title
        this.form.branchId = row.extra.branchId
        this.findPrinterAll(row.extra.branchId)
      } else {
        this.title = '新增菜品标签'
      }
      this.findRestaurantAll()
      this.getAllBranchs()
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    //获取餐厅列表
    async findRestaurantAll() {
      const res = await findAll()
      this.restaurantList = res || []
    },
    // 图片
    image_remove(file, fileList) {
      this.form.icon = ''
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.icon = `${QNHost}/${res.hash}`
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const tagId = this.form.tagId
          const data = Object.assign({}, this.form)
          this.$baseConfirm(
            `你确定要${tagId ? '修改' : '新增'}菜品标签吗`,
            null,
            async () => {
              tagId ? await updateTag(data) : await createTag(data)
              this.$baseMessage(
                `${tagId ? '修改' : '新增'}菜品标签成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}
</style>
